"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileFormLogout = function ProfileFormLogout(_ref) {
  var children = _ref.children,
      onLogoutSuccess = _ref.onLogoutSuccess,
      onError = _ref.onError;

  var logout = function logout() {
    _axios.default.post("/auth/logout").then(function (_ref2) {
      var data = _ref2.data;
      localStorage.removeItem("fiver_react_access_token");
      localStorage.removeItem("fiver_react_refresh_token");
      window.xtremepush("tag", "logout", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      onLogoutSuccess();
    }).catch(function (_ref3) {
      var response = _ref3.response;
      onError(response);
      console.log("response");
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
    type: "button",
    isDanger: true,
    onClick: logout,
    children: children
  });
};

var _default = ProfileFormLogout;
exports.default = _default;